import React, { useEffect, useState } from 'react';
import WebcamComponent from './WebcamComponent';
import PickerFilePreview from './PickerFilePreview';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import CenterPhotoPicker from '../CenterPhotoPicker';
import { useTranslation } from 'react-i18next';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param event setActiveStep to return to the first step
 * @param string classWith: for container size, used when centering the component (w-100, w-400px, other ), but it will always be centered
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param boolean startup: to start the camera outside the component
 * @param useState setStartup: setStartup state to set values when the option to start the camera is used outside the component
 * @param boolean reopenSuggestionShow: to reopen the suggestions modal
 * @param event setReopenSuggestionShow: to assign the value to the variable
 * @param model typeSuggestions: required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
 * @param event handleCancelStream - Event to cancel the camera video stream. If the event is not provided, it will, by default, remove the data from the photoPickerFile model.
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param useState setIsCameraSelected - Event to assign a boolean value indicating whether the camera has already been selected or not.
 * @param state setDisplayModal: State management to ensure only one modal is visible at a time.
 * @param titlePreviewWebcam: Title shown after a photo is taken, along with informational text in the preview of the captured image
 *
 */
const WebcamCustom = (
    {
        setActiveStep, classWith = "content-center-w-400px",
        photoPickerFile, setPhotoPickerFile,
        startup, setStartup,
        reopenSuggestionShow, setReopenSuggestionShow,
        typeSuggestions,
        handleCancelStream = null,
        validateFace = false,
        setIsCameraSelected,
        setDisplayModal = null, // Required when used inside a modal
        titlePreviewWebcam = '',
        isMultipleFile = false // Indicates whether the photograph is added to the list of files of the model
    }
) => {
    const { t } = useTranslation();
    const [selectedCamera, setSelectedCamera] = useState(null);

    const handleDeletePicker = () => {
        setReopenSuggestionShow(false);
        setStartup(false);
        setPhotoPickerFile(prev => ({
            ...prev,
            selfieSrc: null,
            fileSelected: null, // file
            srcSelected: null, // file
        }));
        setStartup(true);
    }

    useEffect(() => {
        if (setIsCameraSelected) {
            setIsCameraSelected(selectedCamera != null)
        }
    }, [selectedCamera]);

    return (<>
        <CenterPhotoPicker classWith={classWith}>
            {!photoPickerFile?.selfieSrc
                ?
                <WebcamComponent
                    photoPicker={photoPickerFile}
                    setPhotoPicker={setPhotoPickerFile}
                    startup={startup}
                    setStartup={setStartup}

                    selectedCamera={selectedCamera}
                    setSelectedCamera={setSelectedCamera}

                    typeSuggestions={typeSuggestions}
                    validateFace={validateFace}
                    setDisplayModal={""}
                    btnCancelStream={() => {
                        setStartup(false);
                        setSelectedCamera(null);
                        if (handleCancelStream) {
                            handleCancelStream();
                        } else {
                            setPhotoPickerFile(prev => ({
                                ...prev,
                                selfieSrc: null,
                                fileSelected: null,
                                srcSelected: null,
                            }));
                            if (setActiveStep) setActiveStep(1);
                            if (setDisplayModal) setDisplayModal('');
                        }
                    }}
                    reopenSuggestionShow={reopenSuggestionShow}
                    isMultipleFile={isMultipleFile}
                />
                :
                <>
                    {titlePreviewWebcam != '' && <p className={"fs-18-to-14 ibl-font-w-600 font-color-general-950 text-center pb-2"}>{t(titlePreviewWebcam)}</p>}

                    <PickerFilePreview
                        accept={{ ...FILE_TYPE.IMAGE }}
                        photoPicker={photoPickerFile}
                        handleDelete={() => {
                            handleDeletePicker();
                        }}
                        showBtnDelete={true}
                    />
                </>
            }
        </CenterPhotoPicker>
    </>)
}

export default WebcamCustom
